<div class="login-container">
  <app-header-title [title]="'Entrar'" [link]="'/auth'"></app-header-title>

  <form [formGroup]="loginForm" class="login-form">
    <div class="form-group">
      <label for="email">E-mail</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        class="form-control"
      />
      @if(loginForm.get('email')?.invalid && loginForm.get('email')?.touched){
      <small class="error"> E-mail é obrigatório </small>
      }
    </div>

    <div class="form-group">
      <label for="password">Senha</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="form-control"
      />
      @if(loginForm.get('password')?.invalid
      &&loginForm.get('password')?.touched){
      <small class="error"> Senha é obrigatória </small>
      }
    </div>
  </form>
  <div class="login-footer">
    @if (errorMessage) {
      <p class="error" role="alert">{{ errorMessage }}</p>
    }
    <button
      (click)="login()"
      type="submit"
      [disabled]="loginForm.invalid"
      class="btn btn-primary"
    >
      {{ linkGoogleAfterLogin ? "ENTRAR E VINCULAR GOOGLE" : "CONTINUAR" }}
    </button>
    <a routerLink="/forgot-password" class="forgot-password"
      >Esqueceu a senha?</a
    >
  </div>
</div>
